'use client';

import { useSyncExternalStore } from 'react';

/**
 * Lightweight "is probably signed in" hint for marketing pages, so they can
 * route CTAs without mounting Clerk (~200 KiB of client JS). Reads Clerk's
 * non-httpOnly `__client_uat` cookie: a positive value means a session exists.
 *
 * The hint is advisory only — every privileged action still validates the real
 * session server-side, and a wrong guess self-corrects (a "signed out" guess
 * routes through /sign-up, which bounces an authenticated user straight back).
 * SSR and the first client render report false to keep hydration stable.
 */
export function useSignedInHint(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

function getSnapshot(): boolean {
  const match = document.cookie.match(/(?:^|;\s*)__client_uat(?:_[^=]+)?=(\d+)/);

  return Boolean(match && Number(match[1]) > 0);
}

// Cookies have no change event; the value only changes across navigations,
// which re-mount the page anyway.
function subscribe(): () => void {
  return () => {};
}
